<template>

  <div class="inner-content">
    <div class="scroll-box">
      <div class="center" :style="{ 'background-image': `url(${$lg(config, 'prize', '')})` }"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Tab1Content',
  inject: ["json_config"],
  computed: {
    config() {
      return this.json_config()
    }
  }
};
</script>


<style lang="scss" scoped>
 .inner-content {
  width: 1040px;
  height: 540px;
  margin: 12px auto 13px;
  overflow: hidden;
  .scroll-box {
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: scroll;
    white-space: pre-line;
    .center{
      width: 100%;
      height: 100%;
      border-radius: 10px;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
    }
  }
}
</style>